import { ArrowLeft } from "lucide-react";
import { Link, useParams } from "react-router-dom";

export default function BackToExecutorDashboardButton() {
  const { estateId } = useParams<{ estateId: string }>();

  return (
    <Link
      to={`/executor-plan/${estateId}/eframe-141`}
      className="inline-flex w-full min-w-[190px] items-center justify-center gap-2 rounded-sm bg-cyan-700 px-6 py-3 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-cyan-800 sm:w-auto"
    >
      <ArrowLeft className="h-4 w-4" aria-hidden="true" />
      Back to Dashboard
    </Link>
  );
}